import React, { useState, useEffect } from 'react';
import { Container, Typography, Button, Box, Stack, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import JobListItem from '../components/jobs/JobListItem';
import JobCreate from '../components/jobs/JobCreate';
import { jobService } from '../services/job';

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const jobsData = await jobService.getJobs();
        setJobs(jobsData);
      } catch (error) {
        console.error('Failed to fetch jobs:', error);
        // You might want to add error handling UI here
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  const handleAddJob = async (newJob) => {
    try {
      const createdJob = await jobService.createJob(newJob);
      setJobs([...jobs, createdJob]);
      setIsModalOpen(false);
    } catch (error) {
      console.error('Failed to create job:', error);
      // You might want to add error handling UI here
    }
  };

  return (
    <Container sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Jobs
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setIsModalOpen(true)}
        >
          Add New Job
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <Stack spacing={2}>
          {jobs.map((job, index) => (
            <JobListItem key={index} job={job} index={index} />
          ))}
        </Stack>
      )}

      <JobCreate
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleAddJob}
      />
    </Container>
  );
};

export default Jobs;
